
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/main-features/automatic-adjustment",
      function () {
        return require("private-next-pages/joy-ui/main-features/automatic-adjustment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/main-features/automatic-adjustment"])
      });
    }
  